import { render } from "./LoginComponent.vue?vue&type=template&id=be324df0&scoped=true"
import script from "./LoginComponent.vue?vue&type=script&lang=js"
export * from "./LoginComponent.vue?vue&type=script&lang=js"

import "@/styles/LoginComponent.css?vue&type=style&index=0&id=be324df0&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be324df0"]])

export default __exports__